export default __webpack_public_path__ + "static/media/userCheck.1aa038c4.svg";